import { useEffect, useState } from 'react';

/* 화면 테마: 브라우저 설정이 아니라 사용자가 고른 값(로그인 화면·상단 버튼). 이 브라우저에만 기억한다. */

export type Theme = 'light' | 'dark';
const KEY = 'selfon.theme';
const listeners = new Set<(t: Theme) => void>();

export function loadTheme(): Theme {
  try { return localStorage.getItem(KEY) === 'dark' ? 'dark' : 'light'; } catch { return 'light'; }
}
export function applyTheme(t: Theme) {
  document.documentElement.dataset.theme = t;
  try { localStorage.setItem(KEY, t); } catch { /* 저장 불가 환경이면 이번 창에서만 */ }
  listeners.forEach((f) => f(t));
}

export function ThemeSwitch({ compact }: { compact?: boolean }) {
  const [theme, setTheme] = useState<Theme>(loadTheme);
  useEffect(() => { listeners.add(setTheme); return () => { listeners.delete(setTheme); }; }, []);
  return (
    <div className={`seg theme-switch${compact ? ' compact' : ''}`} role="group" aria-label="화면 테마">
      {([['light', '☀', '라이트'], ['dark', '☾', '다크']] as const).map(([t, icon, label]) => (
        <button key={t} type="button" className={`btn${theme === t ? ' active' : ''}`} aria-pressed={theme === t} onClick={() => applyTheme(t)} title={`${label} 테마`}>
          <span aria-hidden="true">{icon}</span>{compact ? <span className="sr-only">{label}</span> : ` ${label}`}
        </button>
      ))}
    </div>
  );
}
